import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { LogOut, LayoutDashboard, Sparkles } from "lucide-react";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const dashPath = user?.role === "master" ? "/master" : "/klub";

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-background/70 border-b border-border">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="nav-logo">
          <div className="w-9 h-9 bg-primary flex items-center justify-center text-primary-foreground font-display font-black text-lg">
            U
          </div>
          <div className="leading-none">
            <div className="font-display font-black text-lg tracking-tighter">UPUS CG</div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Članovi</div>
          </div>
        </Link>

        <nav className="flex items-center gap-2 sm:gap-3">
          <Link to="/" className="text-sm font-medium px-3 py-2 hover:text-primary transition-colors hidden sm:block" data-testid="nav-home">
            Klubovi
          </Link>
          {user ? (
            <>
              <Button
                variant="outline"
                className="rounded-none border-2"
                onClick={() => navigate(dashPath)}
                data-testid="nav-dashboard"
              >
                <LayoutDashboard className="w-4 h-4 mr-2" />
                Panel
              </Button>
              <Button
                variant="ghost"
                className="rounded-none"
                onClick={() => {
                  logout();
                  navigate("/");
                }}
                data-testid="nav-logout"
              >
                <LogOut className="w-4 h-4" />
              </Button>
            </>
          ) : (
            <>
              <Button variant="ghost" className="rounded-none" onClick={() => navigate("/prijava")} data-testid="nav-login">
                Prijava
              </Button>
              <Button className="rounded-none bg-primary hover:bg-primary/90" onClick={() => navigate("/registracija")} data-testid="nav-register">
                <Sparkles className="w-4 h-4 mr-2" />
                Registruj klub
              </Button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};
